import type { ComponentProps } from 'react';
import { cn } from '@/shared/lib/utils';
import { Text } from '../text';

type MessageBubbleProps = ComponentProps<'div'> & {
  message?: string;
  position?: 'left' | 'right';
};

export const MessageBubble = ({
  message = 'message...',
  position = 'left',
  className,
  ...props
}: MessageBubbleProps) => {
  return (
    <div className={cn('flex', position === 'left' ? 'justify-start' : 'justify-end')}>
      <div
        className={cn(
          'inline-block',
          position === 'left'
            ? 'rounded-tr-xl rounded-br-xl rounded-bl-xl'
            : 'rounded-tl-xl rounded-br-xl rounded-bl-xl',
          'bg-gradient-to-b from-[#e9f4f0] to-[#d2e9e0]',
          'px-4 py-2',
          'shadow-sm',
          className,
        )}
        {...props}
      >
        <Text variant="body">{message}</Text>
      </div>
    </div>
  );
};
